const typeDefs = '';

export default typeDefs;
